module.exports = __webpack_public_path__ + "static/img/active5.10aeb648.png";